import React, { FunctionComponent } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ApolloProvider } from '@apollo/client';

import apolloClient from 'graphql/apollo';
import { queryClient } from '@api/queryClient';
import { ENV, Environment } from 'config/baseConfig';

interface QueryProvidersProps {
  children: React.ReactNode;
}

export const QueryProviders: FunctionComponent<QueryProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ApolloProvider client={apolloClient}>
      {children}
      {ENV === Environment.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </ApolloProvider>
  </QueryClientProvider>
);

export { queryClient };
